import React from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PropTypes from "prop-types";
import useExpanderTable from "../expander-table/hooks";
import {lighten, makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    accordionSummary: {
        '&:hover, &:focus, &:active': {
            // backgroundColor:  grey[200],
            // backgroundColor:  fade(theme.palette.secondary.light, 0.4),
            backgroundColor: lighten(theme.palette.primary.light, 0.85)
        },
    },
    expanded: {
        // backgroundColor: grey[200],
        // backgroundColor:  fade(theme.palette.secondary.light, 0.4),
        backgroundColor: lighten(theme.palette.primary.light, 0.85)
    },
    accordionDetails: {
        // backgroundColor: grey[50],
        backgroundColor:  lighten(theme.palette.primary.light, 0.95),
    },
}));


const ExpanderTableRows = ({rowKey, SummaryComponent, ContentComponent}) => {
    const classes = useStyles();
    const [state, ] = useExpanderTable();

    if (!state) {
        console.warn("ExpanderTableRows must be a descendant of ExpanderTable")
        return null;
    }

    if (!SummaryComponent) {SummaryComponent = RenderObject}
    if (!ContentComponent) {ContentComponent = RenderObject}

    return (
        <>
        { state.rows.map((row) => (
            <Accordion key={row[rowKey]} square>
                <AccordionSummary
                    classes={{root: classes.accordionSummary, expanded: classes.expanded}}
                    expandIcon={<ExpandMoreIcon/>}
                >
                    <div className="flex flex-row flex-grow font-light">
                        <SummaryComponent row={row}/>
                    </div>
                </AccordionSummary>
                 <AccordionDetails className={classes.accordionDetails}>
                     <ContentComponent row={row}/>
                 </AccordionDetails>
             </Accordion>
            )
        )}
        </>
    )
}

const RenderObject = (row) => (
    <pre>{JSON.stringify(row)}</pre>
)

ExpanderTableRows.propTypes = {
    rowKey           : PropTypes.any.isRequired,
    SummaryComponent : PropTypes.elementType.isRequired,
    ContentComponent : PropTypes.elementType.isRequired,
}

export default ExpanderTableRows;